export default {
  rigid_flex_selector    : 'Flex',
  part_number            : '',
  revision               : '',
  quantities             : ['10', '25', '50', '100'],
  number_of_layers       : '1',
  board_length           : '',
  board_width            : '',
  material_type          : 'Polyimide',
  material_thickness_flex: '0.006',
  finish_plating         : 'ENIG',
  copper_outers          : '0.8 oz',
  silkscreen_sides       : 'Top Side',
  silkscreen_color       : 'White',
  special_instructions   : '',
};
